import { Collab } from "../types/collab";
import { Campaign } from "../types/campaign";

/**
 * True for a UGC collab that only delivers content to the brand and never posts. Copy for these
 * collabs says "delivery", never "post". UGC that also posts, and every influencer collab, return
 * false and keep the posting wording.
 *
 * Requirements come from the collab, falling back to the campaign (the rest of the codebase does the
 * same), else from the collab's content units. A UGC collab posts when a requirement (or unit) names
 * a channel or the collab holds post-link slots — UGC link slots are built from requirement channels
 * (createDeliverableLinksObjectFromContent).
 * deliverableCounts are deliberately ignored: the campaign wizard stores instagramPosts = number of
 * requirements on every UGC campaign and invites copy that onto the collab, so counts say nothing
 * about posting for UGC.
 */
export const isDeliveryOnlyUgc = (
  collab: Partial<Pick<Collab, 'contentRequirements' | 'deliverableLinks' | 'content'>> | null | undefined,
  campaign?: Partial<Pick<Campaign, 'contentRequirements'>> | null,
): boolean => {
  const ownReqs = Object.values(collab?.contentRequirements ?? {});
  const reqs = ownReqs.length > 0 ? ownReqs : Object.values(campaign?.contentRequirements ?? {});
  // Neither side has requirements (legacy collab created before the requirements snapshot, on a
  // campaign whose requirements were later emptied): the collab's own content units still carry the
  // requirement channels they were generated from.
  const withChannels = reqs.length > 0 ? reqs : Object.values(collab?.content ?? {});
  if (withChannels.length === 0) return false;
  if (withChannels.some((r) => (r?.channels?.length ?? 0) > 0)) return false;
  return !Object.values(collab?.deliverableLinks ?? {}).some((links) => (links?.length ?? 0) > 0);
};
